<template>
  <div
    v-if="methods[props.method]"
    :class="bem({ 'greyscale': greyscale, size })"
  >
    <img
      :src="`/images/payment-methods/${methods[props.method].imgId}.png`"
      :class="bem('image')"
      :alt="methods[props.method].alt"
    />
  </div>
</template>

<script setup lang="ts">
const bem = useBEM('PaymentIcon')

const props = defineProps({
  method: { type: String, required: true },
  greyscale: { type: Boolean, default: false},
  size: {type: String, default: 'small', validator:(value:string) => ['x-small', 'small', 'medium'].includes(value)}
})

const methods = {
  visa: { imgId: 1, alt: 'Visa' },
  mastercard: { imgId: 2, alt: 'Mastercard' },
  maestro: { imgId: 3, alt: 'Maestro' },
  paypal: { imgId: 5, alt: 'PayPal' },
  amazon: { imgId: 8, alt: 'Amazon Pay' },
  dinersclub: { imgId: 10, alt: 'Diners Club' },
  discover: { imgId: 14, alt: 'Discover' },
  jcb: { imgId: 16, alt: 'JCB' },
  directdebit: { imgId: 21, alt: 'Direct Debit' },
  americanexpress: { imgId: 22, alt: 'American Express' },
  shopifypay: {imgId: 23, alt: 'Shopify Pay'},
  applepay: {imgId: 25, alt: 'Shopify Pay'},
  googlepay: {imgId: 26, alt: 'Shopify Pay'}
}
</script>

<style lang="postcss">
.PaymentIcon {
  @apply flex items-center justify-center p-0.5
  border border-grey-200 rounded-sm;

  img {
    @apply w-full h-auto;
  }
}

.PaymentIcon--greyscale {
  @apply grayscale opacity-50;
}

.PaymentIcon--size-x-small {
  width: 22px;
  height: 18px;
}

.PaymentIcon--size-small {
  width: 29px;
  height: 24px;
}

.PaymentIcon--size-medium {
  @apply p-2;
  width: 49px;
  height: 40px;
}
</style>